<template>
  <div class="modal-comming">
    <div class="coming-soon">
      <div class="header">COMING SOON</div>
      <div v-if="type==='lotto'" class="desc">
        เช็ครางวัลสลากออมสิน
        ได้ที่นี่ เร็วๆ นี้
      </div>
      <div v-else class="desc">
        ดูข้อมูล Cryptocurrencies
        ได้ที่นี่ เร็วๆ นี้
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["type"]
};
</script>

<style lang="scss" scoped>
.modal-comming {
  position: fixed;
  // z-index: 1061;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background-color: hsla(0, 0%, 100%, 0.8);
  display: table;
  -webkit-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.coming-soon {
  position: relative;
  // top: 50%;
  // left: 45%;
  // margin-top: -50px;
  // margin-left: -100px;
  margin: 0 auto;
  width: 240px;
  min-height: 133px;
  border-radius: 8px;
  box-shadow: 0 0 6px 0 #e9e9e9;
  background-color: $color-white;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @include multipleResponsive(phablet, tablet) {
    height: 160px;
    padding: 10px;
  }
  .header {
    @extend %font-size-l;
    line-height: 1.27;
    text-align: center;
    color: $color-secondary;
  }
  .desc {
    margin: 0 auto;
    text-align: center;
    width: 70%;
    min-height: 30px;
    @extend %font-size-ss;
    line-height: 2;
    color: $color-secondary;
  }
}
</style>